import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import redemCodeService from "./redemCodeService";

export const getRedemCodes = createAsyncThunk(
  "redem-code/get-redem-codes",
  async (params, thunkAPI) => {
    try {
      return await redemCodeService.getRedemCodes(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getRedemCode = createAsyncThunk(
  "redem-code/get-redem-code",
  async (data, thunkAPI) => {
    try {
      return await redemCodeService.getRedemCode(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createRedemCode = createAsyncThunk(
  "redem-code/create-redem-code",
  async (data, thunkAPI) => {
    try {
      return await redemCodeService.createRedemCode(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateRedemCode = createAsyncThunk(
  "redem-code/update-redem-code",
  async (data, thunkAPI) => {
    try {
      return await redemCodeService.updateRedemCode(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteRedemCode = createAsyncThunk(
  "redem-code/delete-redem-code",
  async (data, thunkAPI) => {
    try {
      return await redemCodeService.deleteRedemCode(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateRedemCodeStatus = createAsyncThunk(
  "redem-code/update-redem-code-status",
  async (data, thunkAPI) => {
    try {
      return await redemCodeService.updateRedemCodeStatus(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  redemCodes: [],
  total: 0,
  redemCodeEntryCount: 0,
  redemCode: {},
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
  updating: false,
  isUpdateSuccess: false,
  creating: false,
  isCreateSuccess: false,
  isUpdateStatusSuccess: false,
};
export const redemCodeSlice = createSlice({
  name: "redemCode",
  initialState,
  reducers: {
    initRedemCode: (state) => {
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = false;
      state.message = "";
      state.updating = false;
      state.isUpdateSuccess = false;
      state.creating = false;
      state.isCreateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRedemCodes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getRedemCodes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.redemCodes = action.payload.redemCodes;
        state.total = action.payload.redemCodeCount;
        state.isCreateSuccess = false;
        state.isUpdateSuccess = false;
      })
      .addCase(getRedemCodes.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createRedemCode.pending, (state, action) => {
        state.creating = true;
        state.isCreateSuccess = false;
      })
      .addCase(createRedemCode.rejected, (state, action) => {
        state.isError = true;
        state.creating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(createRedemCode.fulfilled, (state, action) => {
        state.redemCode = action.payload;
        state.creating = false;
        state.isCreateSuccess = true;
      })
      .addCase(updateRedemCode.pending, (state, action) => {
        state.updating = true;
        state.isUpdateSuccess = false;
      })
      .addCase(updateRedemCode.rejected, (state, action) => {
        state.isError = true;
        state.message = action.payload.response.data.message[0];
        state.updating = false;
      })
      .addCase(updateRedemCode.fulfilled, (state, action) => {
        state.redemCode = action.payload;
        state.updating = false;
        state.isUpdateSuccess = true;
      })
      .addCase(updateRedemCodeStatus.pending, (state, action) => {
        state.updating = true;
        state.isUpdateStatusSuccess = false;
        const { id, data } = action.meta.arg;
        state.redemCodes = state.redemCodes.map((customer) =>
          customer.id === id ? { ...customer, ...data } : customer);
      })
      .addCase(updateRedemCodeStatus.rejected, (state, action) => {
        state.isError = true;
        state.updating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(updateRedemCodeStatus.fulfilled, (state, action) => {
        state.updating = false;
        state.isUpdateStatusSuccess = true;
      })

      .addCase(deleteRedemCode.pending, (state, action) => {
        state.updating = true;
        state.isUpdateStatusSuccess = false;
      })
      .addCase(deleteRedemCode.rejected, (state, action) => {
        state.isError = true;
        state.updating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(deleteRedemCode.fulfilled, (state, action) => {
        state.updating = false;
        state.isUpdateStatusSuccess = true;
        const deletedId = action.meta.arg.id;    
        state.redemCodes = state.redemCodes.filter(
          (customer) => customer.id !== deletedId
        );
      })

      .addCase(getRedemCode.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getRedemCode.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.redemCode = action.payload;
      })
      .addCase(getRedemCode.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
  },
});
export default redemCodeSlice.reducer;
export const { initRedemCode } = redemCodeSlice.actions;